module.exports = __webpack_public_path__ + "static/media/avatar23.494f9287.png";